import { TreatmentType } from 'app/core/enums';

/** Returns whether a treatment follows the Neer veneer behavior shared by Veneers and Crystal. */
export function isNeerVeneerLike(treatmentTypeId?: TreatmentType | number | null): boolean {
  return treatmentTypeId === TreatmentType.Veneers || treatmentTypeId === TreatmentType.NeerCrystal;
}
